<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="per_page"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="5"
              offset-md="1"
              class="query-input"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  variant="primary"
                  class="ml-1"
                  @click="OpenCaseReasonModal()"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_CASE_REASON') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          class="position-relative"
          responsive
          :fields="tableFields"
          :items="caseReasonsData"
          show-empty
          :empty-text="$t('DEBTIA_NO_RECORD_MSG')"
        >
          <template #cell(id)="data">
            {{ data.item.id }}
          </template>
          <template #cell(title)="data">
            {{ data.item.title }}
          </template>
          <template #cell(action)="data">
            <feather-icon
              v-b-modal.modal-edit
              icon="EditIcon"
              @click="editCaseReason(data.item)"
            />
            <feather-icon
              icon="Trash2Icon"
              style="margin-left: 15px; cursor: pointer; color: #ff3737;"
              @click="deleteCaseReason(data.item)"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ total }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="current_page"
                :total-rows="total"
                :per-page="per_page"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <add-case-reasons
          ref="addCaseReason"
          :reload-method="getCaseReasons"
        />
        <edit-case-reason-modal
          ref="editCaseReason"
          :edit-case="editCase"
          :reload-method="getCaseReasons"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BTable, BButton, BRow, BCol, BPagination,
} from 'bootstrap-vue'
import i18n from '@/libs/i18n'
import axios from '@axios'
import VSelect from 'vue-select'
import constants from '@/app-configs/constants'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AddCaseReasons from './AddCaseReasons.vue'
import EditCaseReasonModal from './EditCaseReasonModal.vue'

export default {
  name: 'CaseReasons',
  components: {
    BOverlay,
    BCard,
    BTable,
    BButton,
    BRow,
    BCol,
    AddCaseReasons,
    EditCaseReasonModal,
    VSelect,
    BPagination,
  },
  data() {
    return {
      loader: false,
      caseReasonsData: [],
      editCase: {},
      per_page: 10,
      perPageOptions: [10, 25, 50, 100],
      current_page: 1,
      total: 0,
      from: 0,
      to: 0,
    }
  },
  computed: {
    tableFields() {
      return [
        { key: 'id', sortable: true },
        { key: 'title', sortable: true, label: i18n.t('DEBTIA_TITLE') },
        { key: 'action', label: i18n.t('DEBTIA_ACTION') },
      ]
    },
  },
  watch: {
    current_page: {
      handler() {
        this.getCaseReasons()
      },
    },
    per_page: {
      handler() {
        this.currentPage = 1
        this.getCaseReasons()
      },
    },
  },
  created() {
    this.getCaseReasons()
  },
  methods: {
    getCaseReasons() {
      this.loader = true
      const url = `${constants.baseUrl}/reasons?page=${this.current_page}&per_page=${this.per_page}`
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseReasonsData = response.data.data.data.sort((a, b) => a.id - b.id)
          this.total = response.data.data.total
          this.per_page = response.data.data.per_page
          this.to = response.data.data.to
          this.from = response.data.data.from
          this.current_page = response.data.data.current_page
          this.loader = false
        }
      }).catch(error => {
        this.loader = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error.response.data.message,
          },
        })
      })
    },
    OpenCaseReasonModal() {
      this.$refs.addCaseReason.$children[0].show()
    },
    editCaseReason(caseReason) {
      this.$refs.editCaseReason.$children[0].show()
      this.editCase = caseReason
    },
    deleteCaseReason(caseReason) {
      this.loader = true
      const url = `${constants.baseUrl}/reasons/delete/${caseReason.id}`
      axios.delete(url).then(response => {
        if (response.status === 200) {
          this.loader = false
          this.$swal({
            icon: 'success',
            title: 'Deleted!',
            text: i18n.t('DEBTIA_CASE_REASON_DELETED'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          this.getCaseReasons()
        }
      }).catch(error => {
        this.loader = false
        if (error.response && error.response.data.isUsed) {
          this.$swal({
            title: i18n.t('DEBTIA_SURE'),
            text: i18n.t('DEBTIA_CASE_REASON_DELETE_POPUP_TEXT'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: i18n.t('DEBTIA_YES'),
            cancelButtonText: i18n.t('DEBTIA_NO'),
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          }).then(result => {
            if (result.value) {
              const url2 = `${constants.baseUrl}/reasons/delete/${caseReason.id}`
              axios.delete(url2, { data: { forceDelete: true } }).then(response1 => {
                if (response1.status === 200) {
                  this.loader = false
                  this.$swal({
                    icon: 'success',
                    title: 'Deleted!',
                    text: i18n.t('DEBTIA_CASE_REASON_DELETED'),
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                  this.getCaseReasons()
                }
              }).catch(error1 => {
                this.loader = false
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Error',
                    icon: 'CoffeeIcon',
                    variant: 'danger',
                    text: error1.response.data.message,
                  },
                })
              })
            }
          })
        } else if (error.response) {
          this.loader = false
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: error.response.data.message,
            },
          })
        }
      })
    },
  },
}
</script>
